import { useEffect, useState } from "react";
import { createClient } from "@/lib/supabase/client";
import { User } from "@supabase/supabase-js";
import { jwtDecode } from "jwt-decode";

const client = createClient();

export function useUser() {
    const [user, setUser] = useState<User | null>(null);
    const [session, setSession] = useState<{ [key: string]: any }>({});

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const { data, error } = await client.auth.getUser();
                const { data: sessionData, error: sessionError } = await client.auth
                    .getSession();
                if (!error && !sessionError) {
                    if (!sessionData?.session) return;
                    const jwt = jwtDecode(sessionData.session.access_token);
                    setSession(jwt);
                    setUser(data.user);
                } else {
                    setUser(null);
                    setSession({});
                }
            } catch (error) {
                console.error("Error fetching user:", error);
                setUser(null);
                setSession({});
            }
        };

        fetchUser();

        const { data: authListener } = client.auth.onAuthStateChange(
            (event, session) => {
                if (event === "SIGNED_IN" || event === "TOKEN_REFRESHED") {
                    if (!session) return;
                    const jwt = jwtDecode(session.access_token);
                    setSession(jwt);
                    setUser(session.user || null);
                } else if (event === "SIGNED_OUT") {
                    setUser(null);
                    setSession({});
                }
            },
        );

        return () => {
            authListener?.subscription.unsubscribe();
        };
    }, []);

    return { user, session };
}
